export default __webpack_public_path__ + "static/msHoldingLogo-6ffe928bab8a8ef1dcfec4f28c3a2a08.png";